var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"show",rawName:"v-show",value:(_vm.branchOfficeActive),expression:"branchOfficeActive"}]},[(_vm.isAuthenticated)?_c('div',[_c('Sidebar'),_c('Topbar',{staticClass:"rightbar_two"}),_c('router-view')],1):_vm._e(),(!_vm.isAuthenticated)?_c('div',[_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }